<template>
  <div :class="[bemClass(), isCheckedClass, $attrs.class]" :style="$attrs.style">
    <input
      :id="checkboxId"
      v-model="localChecked"
      :class="bemClass('input')"
      :name="name"
      type="checkbox"
      v-bind="{...$attrs, ...attrs}"
    >
    <label :for="checkboxId" :class="bemClass('label')">
      <slot></slot>
    </label>
  </div>
</template>

<script>
import { computed, toRefs } from 'vue'
import useBem from '../../compositions/bem'
import useAttrs from '../../compositions/use-attrs'
import { selGenUniqueId } from '../../util/util'

export default {
  name: 'SelCheckbox',
  inheritAttrs: false,
  props: {
    checked: {
      type: [Boolean, Array],
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    // TODO: Working on this option
    showCheckbox: {
      type: Boolean,
      default: true
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { checked, modifier } = toRefs(props)
    const attrs = useAttrs()
    const { bemClass } = useBem('sel-checkbox', modifier)

    const checkboxId = `checkbox-${selGenUniqueId()}`
    const isCheckedClass = computed(() => checked.value ? 'is-checked' : '')

    const localChecked = computed({
      get () {
        return checked.value
      },
      set (value) {
        emit('update:checked', value)
      }
    })

    function input ($event) {
      emit('update:checked', $event.target.checked)
    }

    return {
      attrs,
      input,
      localChecked,
      bemClass,
      isCheckedClass,
      checkboxId
    }
  }
}
</script>
